import gearImg from '../assets/settings.svg';
import pinImg from '../assets/map-pin.svg';
import timeImg from '../assets/clock.svg';
import bringImg from '../assets/shopping-bag.svg';
import infoImg from '../assets/info.svg';
import alertImg from '../assets/alert-triangle.svg';
import shirtImg from '../assets/shirt.svg';

import React from "react";
import { Tabs } from 'antd';
const { TabPane } = Tabs;

const info = <img src={infoImg}/>
const gear = <img src={gearImg}/>
const pin = <img src={pinImg}/>
const time = <img src={timeImg}/>
const bring = <img src={bringImg}/>
const alert = <img src={alertImg}/>
const shirt = <img src={shirtImg}/>

const insideStyles = {
    background: "white",
    padding: 20,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)"
};

class Activities extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs1: [
                {
                    name: 'EBike City Tour',
                    img: 'https://dynamic-media.tacdn.com/media/photo-o/2e/c9/e9/52/caption.jpg?w=1400&h=1000&s=1',
                    text: <div>
                        <div><strong>Glide through Gaudi's Highlights</strong> - Step into the world of a visionary as you pedal through the streets that inspired Antoni Gaudí's legendary creations. From the charming, narrow alleys of the Born to the majestic Sagrada Familia, this eBike tour uncovers the stories behind Barcelona's most iconic modernist landmarks while immersing you in the vibrant urban energy. Feel the heartbeat of the city as you explore hidden gems and experience firsthand how Gaudí's genius reshaped Barcelona into a living masterpiece.</div>
                        <br />
                        <p><b>Please note</b></p>
                        <div>{time} Duration: 2h45</div>
                        <div>{info} Max 15 participants per group</div>
                        <div>{pin} Starting at hotel and return for lunch near the hotel</div>
                        <div>{gear} Optional headsets will be provided for guided explanations throughout the ride</div>
                    </div>
                },
                {
                    name: 'City Sailing Catamaran',
                    img: 'https://i.imgur.com/LYvdRfI.png',
                    text: <div>
                        <div><strong>Explore the City Skyline from the Sea</strong> - Experience the serene beauty of the Mediterranean Sea aboard a luxurious catamaran in Barcelona, where the tranquil waters and gentle sea breezes create the perfect setting for a day of unforgettable sailing. As you set sail from the vibrant city, the stunning coastline unfolds before you, offering panoramic views of the sparkling azure sea and the beautiful skyline of Barcelona.</div>
                        <br />
                        <p><b>Please note</b></p>
                        <div> {alert} No need to bring a swimsuit—just come ready to relax and enjoy the sun! </div>
                        <div>{time} Duration: 2.5h</div>
                        <div>{info} Max 60 participants</div>
                        <div>{info} Sailing & bus drive combination</div>
                        <div>{bring} Includes: Lunch, snacks and drinks</div>
                    </div>
                },
                {
                    name: 'Artisan Workshop',
                    img: 'https://i.imgur.com/RArFa9z.png',
                    text: <div>
                        <div><strong>Discover Alpargatas Art & Create a Masterpiece</strong> - Step into the heart of Barcelona's Gothic Quarter for a magical workshop experience. Enter a charming, centuries-old shop and be transported to a time when artisans carefully hand-made each pair of shoes with love and skill. Discover the rich tradition of Catalan footwear, known for its comfort and craftsmanship, guided by local artisans who will share the intricate techniques behind these timeless creations.</div>
                        <br />
                        <p><b>Please note</b></p>
                        <div>{time} Duration: 2.5 hours</div>
                        <div>{info} Maximum participants: 20</div>
                        <div>{info} Walking & bus drive combination</div>
                        <div>{shirt} For Women: Create your own pair of traditional alpargatas and take them home as a one-of-a-kind souvenir.</div>
                        <div>{shirt} For Men: Craft a miniature shoe keychain and receive a stylish pair of moccasins as a gift.</div>
                        <div>{bring} Enjoy a warm welcome with coffee and light snacks, followed by a delightful lunch near the workshop location after the activity.</div>
                    </div>
                },
            ],
            tabs2: [
                {
                    name: 'Catalan Festival',
                    img: 'https://i.imgur.com/qCy58d4.jpeg',
                    text: <div>
                        <div>We'll kick things off with a choose-your-own-adventure experience:</div>
                        <div><strong>Seeking excitement?</strong> Join us for an exhilarating quad bike ride through the vineyards and scenic paths of a charming Catalan village.</div>
                        <div><strong>Prefer a more relaxed vibe?</strong> Settle in on the grass with a glass of wine and let your creativity flow in a guided open-air Art & Wine painting session, surrounded by the stunning views of the Montserrat Mountains.</div>
                        <div>Afterward, we'll come together to celebrate at an authentic Catalan festival — with live music, local flavors, and plenty of joy!</div>
                    </div>
                }
            ],
            wrappertabs: [
                {
                    name: "Main Activity",
                    keyToRender: 'tabs2',
                },
                {
                    name: "Individual Activities",
                    keyToRender: 'tabs1',
                }
            ],
        }
    }



    render() {
        const {wrappertabs} = this.state;
        return <div id="activities">
            <h1>Activities</h1>
            <div  className="content">
                <Tabs type="card">
                    {wrappertabs.map((tab, index) =>
                        <TabPane tab={tab.name} type="card" key={index}>
                            <Tabs type="card">
                            {this.state[tab.keyToRender].map((subtab, subindex) =>
                                <TabPane tab={subtab.name} className="tab-content" key={subindex}>
                                    <h2 className="tab-title">{subtab.name}</h2>
                                    <img src={subtab.img} className="tab-img"/>
                                    <div className="tab-text">{subtab.text}</div>
                                </TabPane>)
                            }
                            </Tabs>
                        </TabPane>
                    )}
                </Tabs>
            </div>
        </div>;
    }
}

export default Activities;
